import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// import JS files
import Navbar from "../shares/others/Navbar";
import ImgList from "../shares/others/ImgList";
import TextList from "../shares/others/TextList";
import Footer from "../shares/others/Footer";
import Header from "./Header";
import Content from "./Content";
import Share from "./Share";
import Writter from "./Writter";
import Hashtag from "./Hashtag";
import NextPrevNews from "./NextPrevNews";
import CommentForm from "./CommentForm";
import CommentsList from "./CommentsList";
import VideoPlayer from "../shares/others/VideoPlayer";
import MuiButton from "../shares/mui/MuiButton";
import PicReports from "./PicReports";
import useFetch from "../../context/useFetch";
import { useAuth } from "../../context/AuthContext";
import ImageGallery from "./ImageGallery";

// import others files

const NewsContent = (props) => {
  const navigate = useNavigate();
  const [newsType, setNewsType] = useState("news");
  const [newsDetail, setNewsDetail] = useState({});
  const { token } = useAuth();
  const { id } = useParams();
  const getNewsDetailApi = useFetch({
    method: "get",
    url: `News_Service/${id}`,
    noHeader: token ? false : true,
    trigger: true,
    argFunc: (res) => {
      setNewsType(res.type);
      setNewsDetail(res);
    },
  });
  const [patchData, setPatchData] = useState();
  const updateNewsDetailApi = useFetch({
    method: "patch",
    url: `News_Service/${id}`,
    data: patchData,
    noHeader: token ? false : true,
    trigger: false,
    argFunc: (res) => {
      navigate("/");
    },
  });
  const updateNewsCount = useFetch({
    method: "get",
    url: `News_Service/${id}/update_news_view`,
    noHeader: true,
    trigger: token ? false : true,
    argFunc: (res) => {},
  });

  const publish_news = (stat) => {
    setPatchData({ is_publish: stat });
    updateNewsDetailApi.reFetch();
  };

  useEffect(() => {
    getNewsDetailApi.reFetch();
  }, [id]);

  return (
    <>
      <Navbar active_item="" />
      <div className="mx-8 2xl:mx-32 mb-8">
        {Object.keys(newsDetail).length > 0 && (
          <div className="grid md:grid-cols-8 md:gap-4 mt-8 ">
            <div className="md:col-span-5 ">
              {newsType == "news" ? (
                <img
                  src={newsDetail.news_detail[0].cover}
                  className="md:h-[36rem] w-full rounded-xl"
                />
              ) : newsType == "video" ? (
                <VideoPlayer
                  src={newsDetail.news_detail_multi[0].video_file}
                  poster={newsDetail.news_detail[0].cover}
                />
              ) : (
                <>
                  <img
                    src={newsDetail.news_detail[0].cover}
                    className="md:h-[36rem] w-full rounded-xl"
                  />
                  <PicReports />
                </>
              )}

              <div className="mt-8">
                <Header
                  view_number={newsDetail.view_number}
                  ticket_num={newsDetail.ticket_num}
                  header={newsDetail.news_detail[0].header}
                  sub_header={newsDetail.news_detail[0].sub_header}
                  publish_at={newsDetail.news_detail[0].publish_at}
                  created_at={newsDetail.news_detail[0].created_at}
                  id={newsDetail.id}
                />
                <Content paragraphs={newsDetail.news_paragraph_file} />
                <ImageGallery />
                <Share />
                <Writter writer={newsDetail.writer_detail} />
                {newsDetail.news_tag_file.length > 0 ? (
                  <Hashtag tags={newsDetail.news_tag_file} />
                ) : (
                  ""
                )}
                {!token && (
                  <>
                    <NextPrevNews />
                    <CommentForm />
                    <CommentsList />
                  </>
                )}
                {token && (
                  <div className="mt-4 flex justify-end">
                    {newsDetail.is_publish ? (
                      <div className="mr-4">
                        <MuiButton
                          onClick={() => {
                            publish_news(false);
                          }}
                          variant="contained"
                          color="error"
                          text="غیر فعال کردن خبر"
                        />
                      </div>
                    ) : (
                      <MuiButton
                        onClick={() => {
                          publish_news(true);
                        }}
                        variant="contained"
                        color="success"
                        text="انتشار خبر"
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="md:col-span-3 mt-4 md:mt-0  ">
              <ImgList />
              <div className="mt-8">
                <TextList header="پربیننده‌ترین" />
              </div>
              <div className="mt-8">
                <TextList AllNews header="آخرین مطالب" />
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default NewsContent;
